<template>
    <div class="wrapper">
        <NavBar />
        <Menu />
        <!-- Spinner Start -->
        <div class="modal fade" id="costumModalpeta" data-easein="flipBounceYIn" tabindex="-1" role="dialog"
            aria-labelledby="costumModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false"
            style="background: rgba(240, 248, 255, 0.1);">
            <div class="modal-dialog modal-fullscreen" style="width: 45vw;height: 60%;">
                <div class="modal-content" style="height: auto;min-width: 45vw; min-height: 60%;">
                    <div class="modal-header">
                        <h4 class="modal-title">Pengaturan Dokumen KPI 2</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body text-justify" style="height: auto;min-width: 45vw; min-height: 60%;">
                        <p>
                        <div class="row p-3">
                            <div class="col-sm-2" style="padding: 5px;">
                                Kota
                            </div>
                            <div class="col-sm-10" style="padding: 5px;">
                                <select class="form-control form-control-sm custom-select" @change="cekisi('kota1')"
                                    :id="'kota1'">
                                    <template v-for="(datapilihannya, urutpilihannya) in lokasi" :key="urutpilihannya">
                                        <option :value="datapilihannya.tag" :selected="datapilihannya.tag == kota1">
                                            {{
                                                datapilihannya.label
                                            }}
                                        </option>
                                    </template>
                                </select>
                            </div>
                            <div class="col-sm-2" style="padding: 5px;">
                                Tahun
                            </div>
                            <div class="col-sm-10" style="padding: 5px;">
                                <input type="number" class="form-control form-control-sm" :id="'tahun'" :name="'tahun'"
                                    placeholder="Tahun" style="width: 100px !important;" :value="tahun">
                            </div>
                            <div class="col-sm-2" style="padding: 5px;">
                                Jenis Dokumen
                            </div>
                            <div class="col-sm-10" style="padding: 5px;">
                                <select class="form-control form-control-sm custom-select" @change="cekisi('peraturan')"
                                    :id="'peraturan'">
                                    <template v-for="(datapilihannya, urutpilihannya) in peraturan" :key="urutpilihannya">
                                        <option :value="datapilihannya.tag" :selected="datapilihannya.tag == jenis">
                                            {{
                                                datapilihannya.label
                                            }}
                                        </option>
                                    </template>
                                </select>
                            </div>
                            <div class="col-sm-2" style="padding: 5px;">
                                Nama Dokumen
                            </div>
                            <div class="col-sm-10" style="padding: 5px;">
                                <input type="text" class="form-control form-control-sm" :id="'nama'" :name="'nama'"
                                    placeholder="Nama Dokumen" :value="nama">
                            </div>
                            <div class="col-sm-2" style="padding: 5px;">
                                Dokumen
                            </div>
                            <div class="col-sm-10" style="padding: 5px;">
                                <a :href="pdfnyafilenya_undangan_rapat_1 + filenya_undangan_rapat_1" target="_blank"
                                    v-if="filenya_undangan_rapat_1 != '' && filenya_undangan_rapat_1 != null">Lihat
                                    Dokumen</a>
                                <input type="hidden" class="form-control form-control-sm"
                                    :id="'filenya_undangan_rapat_1'" :name="'filenya_undangan_rapat_1'"
                                    placeholder="Dokument" readonly :value="(filenya_undangan_rapat_1)">
                                <input type="file" class="form-control form-control-sm"
                                    :id="'fileToUploadfilenya_undangan_rapat_1'"
                                    :name="'fileToUploadfilenya_undangan_rapat_1'" placeholder="fileToUpload"
                                    style="font-size: smaller;" accept="application/pdf">
                                <br>
                                <div class="progress">
                                    <div class="progress-bar" role="progressbar" aria-valuenow="0" aria-valuemin="0"
                                        aria-valuemax="100" style="width:0%" :id="'persennyafilenya_undangan_rapat_1'">
                                        <span :id="'tulisanpersenfilenya_undangan_rapat_1'">0%</span>
                                    </div>
                                </div>
                                <br>
                                <span class="text-success" :id="'suksesnyafilenya_undangan_rapat_1'"></span>
                                <br>
                                <button type="button" class="btn btn-warning btn-sm lebar text-white"
                                    @click="uploadfile('filenya_undangan_rapat_1', 'application/pdf')">Upload
                                    File</button>
                                <button type="button" class="btn btn-danger btn-sm lebar"
                                    @click="clearfilepeta('filenya_undangan_rapat_1')">Hapus
                                    File</button>
                            </div>
                        </div>
                        </p>
                    </div>
                    <div class="modal-footer text-center">
                        <div class="col-sm-12 text-center">
                            <button type="button" class="btn btn-success btn-sm lebar2 text-white" v-if="mode==''"
                                @click="simpandata()">
                                Simpan
                            </button>
                            <button type="button" class="btn btn-success btn-sm lebar2 text-white" v-if="mode=='edit'"
                                @click="updatedata()">
                                Update
                            </button>
                            <button type="button" class="btn btn-danger3 btn-sm lebar2 text-white" data-dismiss="modal">
                                <i class="far fa-times-circle"></i>
                                Tutup</button>
                        </div>
                    </div>
                    <div class="col-sm-12">&nbsp;</div>
                    <div class="col-sm-12">&nbsp;</div>
                    <div class="col-sm-12">&nbsp;</div>
                    <div class="col-sm-12">&nbsp;</div>
                </div>
                <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
        </div>
        <div id="spinner" v-if="halamanloading"
            class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
            style="opacity: 0.5;">
            <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <!-- Spinner End -->
        <div class="content-wrapper py-3">
            <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6 wow fadeInDown">
                            <h5>Pengaturan</h5>
                        </div>
                        <div class="col-sm-6 wow fadeInDown">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item"><a href="/Dashboard">Home </a></li>
                                <li class="breadcrumb-item"><a href="/Monev">Monitoring Evaluasi</a></li>
                                <li class="breadcrumb-item active">Pengaturan KPI 2</li>
                            </ol>
                        </div>
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
            </div>
            <!-- /.content-header -->
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-sm-12 wow fadeInDown">
                            <div class="card cardputih2">
                                <div class="card-header border-transparent">
                                    <h3 class="card-title">Daftar KPI 2</h3>
                                </div>
                                <div class="card-body p-3">
                                    <div class="row p-3">
                                        <div class="col-sm-12">
                                            Paket Pekerjaan: {{ Nama_Kegiatan }}
                                        </div>
                                        <div class="col-sm-12">&nbsp;</div>
                                        <div class="card direct-chat direct-chat-primary">
                                            <div class="card-header ui-sortable-handle">
                                                <button type="button"
                                                    class="btn btn-sm btn-primary3 float-left text-white lebar2"
                                                    @click="tambah()" data-toggle="tooltip" data-placement="left"
                                                    title="tambah dokumen.."><i class="fas fa-plus"></i>
                                                    Tambah</button>
                                            </div>
                                            <div class="body">
                                                <div class="row p-3">
                                                    <div class="col-sm-12">
                                                        <div class="table-responsive table-wrapper"
                                                            style="min-height: 60vh !important;">
                                                            <table class="table m-0" id="tabeldata"
                                                                style="font-size: small;">
                                                                <thead>
                                                                    <tr>
                                                                        <th style="width: 50px;">No</th>
                                                                        <th style="width: 100px;">Kota</th>
                                                                        <th style="width: 100px;">Tahun</th>
                                                                        <th style="width: 100px;">Jenis</th>
                                                                        <th style="width: 250px;">Nama</th>
                                                                        <th style="width: 100px;">Dokumen</th>
                                                                        <th style="width: 50px;">Opsi</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <template v-for="(datadata, urutdata) in datamaster"
                                                                        :key="urutdata">
                                                                        <tr>
                                                                            <td>{{ urutdata + 1 }}</td>
                                                                            <td> {{ datadata.namakota }}</td>
                                                                            <td> {{ datadata.tahun }}</td>
                                                                            <td> {{ datadata.namajenis }}</td>
                                                                            <td> {{ datadata.nama }}</td>
                                                                            <td>
                                                                                <a :href="pdfnyafilenya_undangan_rapat_1 + datadata.filenya_undangan_rapat_1"
                                                                                    target="_blank"
                                                                                    v-if="datadata.filenya_undangan_rapat_1 != '' && datadata.filenya_undangan_rapat_1 != null">Lihat
                                                                                    Dokumen</a>
                                                                            </td>
                                                                            <td>
                                                                                <button type="button"
                                                                                    style="width: 90px;"
                                                                                    class="btn btn-primary3 btn-sm text-white"
                                                                                    @click="prosesdata(datadata.id)"
                                                                                    data-toggle="tooltip"
                                                                                    data-placement="left"
                                                                                    title="Edit data.."><i
                                                                                        class="fas fa-edit"></i> Edit
                                                                                </button>
                                                                                <button type="button"
                                                                                    style="width: 90px;"
                                                                                    class="btn btn-warning btn-sm text-white"
                                                                                    @click="hapus(datadata.id)"
                                                                                    data-toggle="tooltip"
                                                                                    data-placement="left"
                                                                                    title="Hapus data.."><i
                                                                                        class="far fa-trash-alt"></i>
                                                                                    Hapus
                                                                                </button>
                                                                            </td>
                                                                        </tr>
                                                                    </template>

                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">&nbsp;</div>
                                    </div>
                                </div>
                                <div class="card-footer p-3">
                                    <button style="display: none;" type="button" class="btn btn-sm btn-success3 float-left text-white lebar2"
                                        @click="simpan()" data-toggle="tooltip" data-placement="left"
                                        title="Simpan data.."><i class="fas fa-plus-square"></i>
                                        Simpan</button>
                                    <button type="button" class="btn btn-sm btn-danger3 float-left text-white lebar2"
                                        @click="batalproses()" data-toggle="tooltip" data-placement="left"
                                        title="Batalkan proses.."><i class="fas fa-window-close"></i>
                                        Tutup</button>
                                </div>
                                <div class="col-sm-12">&nbsp;</div>
                                <div class="col-sm-12">&nbsp;</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import $ from 'jquery';
import axios from 'axios';
import vSelect from 'vue-select';
import swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
import { useRoute } from 'vue-router';
import { watch } from 'vue';
import { quillEditor } from 'vue3-quill';
import Footer from "../../componen/Footer.vue";
import NavBar from "../../componen/NavBar.vue";
import Menu from "../../componen/Menu.vue";

import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
export default {
    setup() {
        const route = useRoute()
        watch(() => route.name, () => {
        });

        return { route };
    },
    components: {
        Footer, NavBar, Menu, vSelect, swal, quillEditor
    },
    data() {
        return {
            halamanloading: true,
            iduser: JSON.parse(localStorage.getItem("usistem")),
            leveluser: JSON.parse(localStorage.getItem("lsistem")),
            namauser: JSON.parse(localStorage.getItem("nmusistem")),
            secretencData: decodeURIComponent(CryptoJS.AES.decrypt(this.route.params.id, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString(CryptoJS.enc.Utf8)),
            Nama_Kegiatan: '',
            jumlahminggu: '',
            datatahun: [],
            datamaster: [],
            validasi: false,
            idnya: '',
            no_sk: '',
            tanggal_sk: '',
            datapesan: '',
            filenya_lampiran_sk: '',
            pdfnyafilenya_lampiran_sk: process.env.VUE_APP_URL_API + 'parastapainnovation_lampiranpdo3-PDF?f=',
            filenya_lampiran_apbd: '',
            pdfnyafilenya_lampiran_apbd: process.env.VUE_APP_URL_API + 'parastapainnovation_lampiranpdo3-APDB?f=',
            anggaran_apbd: 0,
            rencana_program: 0,
            filenya_lampiran_program: '',
            pdfnyafilenya_lampiran_program: process.env.VUE_APP_URL_API + 'parastapainnovation_lampiranpdo3-Program?f=',
            tanggal_rapat_1: '',
            tanggal_rapat_2: '',
            tanggal_rapat_3: '',
            tanggal_rapat_4: '',
            filenya_undangan_rapat_1: '',
            pdfnyafilenya_undangan_rapat_1: process.env.VUE_APP_URL_API + 'parastapainnovation_lampiranpdo3undangan1-PDF?f=',
            filenya_undangan_rapat_2: '',
            pdfnyafilenya_undangan_rapat_2: process.env.VUE_APP_URL_API + 'parastapainnovation_lampiranpdo3undangan2-PDF?f=',
            filenya_undangan_rapat_3: '',
            pdfnyafilenya_undangan_rapat_3: process.env.VUE_APP_URL_API + 'parastapainnovation_lampiranpdo3undangan3-PDF?f=',
            filenya_undangan_rapat_4: '',
            pdfnyafilenya_undangan_rapat_4: process.env.VUE_APP_URL_API + 'parastapainnovation_lampiranpdo3undangan4-PDF?f=',
            filenya_notulensi_rapat_1: '',
            pdfnyafilenya_notulensi_rapat_1: process.env.VUE_APP_URL_API + 'parastapainnovation_lampiranpdo3notulensi1-PDF?f=',
            filenya_notulensi_rapat_2: '',
            pdfnyafilenya_notulensi_rapat_2: process.env.VUE_APP_URL_API + 'parastapainnovation_lampiranpdo3notulensi2-PDF?f=',
            filenya_notulensi_rapat_3: '',
            pdfnyafilenya_notulensi_rapat_3: process.env.VUE_APP_URL_API + 'parastapainnovation_lampiranpdo3notulensi3-PDF?f=',
            filenya_notulensi_rapat_4: '',
            pdfnyafilenya_notulensi_rapat_4: process.env.VUE_APP_URL_API + 'parastapainnovation_lampiranpdo3notulensi4-PDF?f=',
            filenya_dokumentasi_rapat_1: '',
            pdfnyafilenya_dokumentasi_rapat_1: process.env.VUE_APP_URL_API + 'parastapainnovation_lampiranpdo3dokumentasi1-PDF?f=',
            filenya_dokumentasi_rapat_2: '',
            pdfnyafilenya_dokumentasi_rapat_2: process.env.VUE_APP_URL_API + 'parastapainnovation_lampiranpdo3dokumentasi2-PDF?f=',
            filenya_dokumentasi_rapat_3: '',
            pdfnyafilenya_dokumentasi_rapat_3: process.env.VUE_APP_URL_API + 'parastapainnovation_lampiranpdo3dokumentasi3-PDF?f=',
            filenya_dokumentasi_rapat_4: '',
            pdfnyafilenya_dokumentasi_rapat_4: process.env.VUE_APP_URL_API + 'parastapainnovation_lampiranpdo3dokumentasi4-PDF?f=',

            filenya_absensi_rapat_1: '',
            pdfnyafilenya_absensi_rapat_1: process.env.VUE_APP_URL_API + 'parastapainnovation_lampiranpdo3absensi1-PDF?f=',
            filenya_absensi_rapat_2: '',
            pdfnyafilenya_absensi_rapat_2: process.env.VUE_APP_URL_API + 'parastapainnovation_lampiranpdo3absensi2-PDF?f=',
            filenya_absensi_rapat_3: '',
            pdfnyafilenya_absensi_rapat_3: process.env.VUE_APP_URL_API + 'parastapainnovation_lampiranpdo3absensi3-PDF?f=',
            filenya_absensi_rapat_4: '',
            pdfnyafilenya_absensi_rapat_4: process.env.VUE_APP_URL_API + 'parastapainnovation_lampiranpdo3absensi4-PDF?f=',
            tahunmulai: [],
            datatahunmulai: [],
            defaultSelectedtahunmulai: {
                code: 0,
                label: 'Pilih Data',
                tag: '',
            },
            selectedtahunmulai: '',
            tahun: new Date().getFullYear(),
            lokasi: [],
            datalokasi: [],
            defaultSelectedlokasi: {
                code: 0,
                label: 'Pilih Lokasi',
                tag: '',
            },
            selectedlokasi: '',
            kota1: '',
            kota2: '',
            kota3: '',
            kota4: '',
            tahun: '',
            jenis: '',
            project_id: process.env.VUE_APP_PROJECT_ID,
            iddata: '',
            peraturan: [],
            dataperaturan: [],
            defaultSelectedperaturan: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedperaturan: '',
            mode: '',
        }
    },
    methods: {
        async ambildatareff() {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();
            await mainAPI5.get("parastapainnovationperaturan-Reff?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.dataperaturan = [];
                        this.peraturan = [];
                        this.dataperaturan = Response.data.content.data;
                        this.dataperaturan.forEach((item) => {
                            this.peraturan.push({
                                label: item.nama,
                                code: this.dataperaturan.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.peraturan.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });
        },
        cekisi(isinya) {
            //alert(document.getElementById(isinya).value);
        },
        initialize() {
            //Initialize Select2 Elements
            $(".select2").select2();

            //Initialize Select2 Elements
            $(".select2bs4").select2({
                theme: "bootstrap4",
            });
            $('[data-mask]').inputmask();
            //$('#summernote').summernote();
        },
        ontahunmulaiChange(a) {
            try {
                this.selectedtahunmulai = this.tahunmulai[a].tag;
            }
            catch (err) {
                return;
            }
            this.AmbilDataSingel();
        },
        tambah() {
            $('#costumModalpeta').modal('show');
        },
        simpandata() {
            //alert(document.getElementById('kota1').value);
            //alert(document.getElementById('tahun').value);
            //alert(document.getElementById('filenya_undangan_rapat_1').value);
            var fd = new FormData();

            fd.append("kota1", document.getElementById('kota1').value);
            fd.append("tahun", document.getElementById('tahun').value);
            fd.append("jenis", document.getElementById('peraturan').value);
            fd.append("nama", document.getElementById('nama').value);
            fd.append("kode", this.idnya);
            fd.append("project_id", this.project_id);
            fd.append("filenya_undangan_rapat_1", document.getElementById('filenya_undangan_rapat_1').value);
            fd.append("updatedby", JSON.parse(localStorage.getItem("isistem")));

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovation_kpi2-Simpan", fd).then(
                Response => {
                    var bytes = encodeURIComponent(CryptoJS.AES.encrypt(this.secretencData, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
                    if (Response.data.response == 'error') {
                        swal.fire('Peringatan', Response.data.message, 'error');
                    }
                    else {
                        swal.fire('Informasi', 'Data telah tersimpan..', 'success').then(function () {
                            document.location.reload();
                        });
                        $('.swal2-container').css("z-index", '999999');
                    }
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )
        },
        updatedata() {
            //alert(document.getElementById('kota1').value);
            //alert(document.getElementById('tahun').value);
            //alert(document.getElementById('filenya_undangan_rapat_1').value);
            var fd = new FormData();
            //alert(this.tahun);
            //return;
            fd.append("kota1", document.getElementById('kota1').value);
            fd.append("tahun", document.getElementById('tahun').value);
            fd.append("jenis", document.getElementById('peraturan').value);
            fd.append("nama", document.getElementById('nama').value);
            fd.append("kode", this.idnya);
            fd.append("id", this.iddata);
            fd.append("project_id", this.project_id);
            fd.append("filenya_undangan_rapat_1", document.getElementById('filenya_undangan_rapat_1').value);
            fd.append("updatedby", JSON.parse(localStorage.getItem("isistem")));

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovation_kpi2-Update", fd).then(
                Response => {
                    var bytes = encodeURIComponent(CryptoJS.AES.encrypt(this.secretencData, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
                    if (Response.data.response == 'error') {
                        swal.fire('Peringatan', Response.data.message, 'error');
                    }
                    else {
                        swal.fire('Informasi', 'Data telah terupdate..', 'success').then(function () {
                            document.location.reload();
                        });
                        $('.swal2-container').css("z-index", '999999');
                    }
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )
        },
        hapus(kode) {
            swal.fire({
                title: "Konfirmasi",
                text: "Yakin Hendak Hapus Data?",
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: "Batal",
                confirmButtonColor: "#3a4767",
                cancelButtonColor: "#ffaa05",
                confirmButtonText: "Hapus"
            }).then((result) => {
                if (result.isConfirmed) {
                    const data = { kode: kode, project_id: this.project_id, deletedby: JSON.parse(localStorage.getItem("isistem")) }
                    const mainAPI = axios.create({
                        baseURL: process.env.VUE_APP_URL_API,
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                            "Content-Type": "application/x-www-form-urlencoded",
                        },
                    });
                    mainAPI.post("parastapainnovation_kpi2-Hapus", data).then(
                        Response => {
                            var bytes = encodeURIComponent(CryptoJS.AES.encrypt(this.secretencData, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
                            if (Response.data.response == 'error') {
                                swal.fire('Peringatan', Response.data.message, 'error');
                            }
                            else {
                                swal.fire('Informasi', 'Data telah dihapus..', 'success').then(function () {
                                    document.location.reload()
                                });
                            }
                        }
                    ).catch(
                        error => {
                            swal.fire('Peringatan', 'Terjadi Kesalahan Format Data', 'error');
                        }
                    )

                }
            });
            return false;
        },
        async prosesdata(kode) {
            this.mode = 'edit';
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            //alert(this.selectedid_user);
            await mainAPI.get("parastapainnovation_kpi2-Cari?random=" + random + "&project_id=" + this.project_id + "&kode=" + this.secretencData + "&id=" + kode + "&create=" + JSON.parse(localStorage.getItem("isistem"))).then(
                Response => {
                    this.datapesan = Response.data.message;
                    this.kota1 = '';
                    this.tahun = '';
                    this.iddata = '';
                    this.filenya_undangan_rapat_1 = '';
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.iddata = Response.data.content.data[0].id;
                        this.kota1 = Response.data.content.data[0].kota1;
                        this.tahun = Response.data.content.data[0].tahun;
                        this.nama = Response.data.content.data[0].nama;
                        this.jenis = Response.data.content.data[0].jenis;
                        this.filenya_undangan_rapat_1 = Response.data.content.data[0].filenya_undangan_rapat_1;
                        document.getElementById('filenya_undangan_rapat_1').value = Response.data.content.data[0].filenya_undangan_rapat_1;
                        $('#costumModalpeta').modal('show');
                        this.halamanloading = false;
                    }
                    else {
                        this.kota1 = '';
                        this.tahun = '';
                        this.iddata = '';
                        this.filenya_undangan_rapat_1 = '';
                        document.getElementById('filenya_undangan_rapat_1').value = '';
                        this.halamanloading = false;
                    }

                }
            ).catch(error => {
                //console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });
        },
        bataledit() {
            this.mode = '';
            this.tanggal = '';
            this.idnya = '';
            this.target_penyelesaian = '';
            this.kendala = '';
            this.tindaklanjut = '';
            this.penanggungjawab = '';
            this.filenya_kendala = '';
            document.getElementById('filenya_kendala').value = '';
        },
        simpan() {
            var fd = new FormData();
            var rencana_program = 0;
            if (document.getElementById('checkboxPrimary1').checked == true) {
                rencana_program = 1;
            }
            var kota1 = document.getElementById("kota1").value;
            var kota2 = document.getElementById("kota2").value;
            var kota3 = document.getElementById("kota3").value;
            var kota4 = document.getElementById("kota4").value;

            fd.append("tahun", this.selectedtahunmulai);
            fd.append("kode", this.idnya);
            fd.append("no_sk", this.no_sk);
            fd.append("tanggal_sk", this.tanggal_sk);
            fd.append("filenya_lampiran_sk", document.getElementById('filenya_lampiran_sk').value);
            fd.append("anggaran_apbd", this.anggaran_apbd);
            fd.append("filenya_lampiran_apbd", document.getElementById('filenya_lampiran_apbd').value);
            fd.append("rencana_program", rencana_program);
            fd.append("filenya_lampiran_program", document.getElementById('filenya_lampiran_program').value);
            fd.append("tanggal_rapat_1", this.tanggal_rapat_1);
            fd.append("filenya_undangan_rapat_1", document.getElementById('filenya_undangan_rapat_1').value);
            fd.append("filenya_notulensi_rapat_1", document.getElementById('filenya_notulensi_rapat_1').value);
            fd.append("filenya_dokumentasi_rapat_1", document.getElementById('filenya_dokumentasi_rapat_1').value);
            fd.append("filenya_absensi_rapat_1", document.getElementById('filenya_absensi_rapat_1').value);
            fd.append("tanggal_rapat_2", this.tanggal_rapat_2);
            fd.append("filenya_undangan_rapat_2", document.getElementById('filenya_undangan_rapat_2').value);
            fd.append("filenya_notulensi_rapat_2", document.getElementById('filenya_notulensi_rapat_2').value);
            fd.append("filenya_dokumentasi_rapat_2", document.getElementById('filenya_dokumentasi_rapat_2').value);
            fd.append("filenya_absensi_rapat_2", document.getElementById('filenya_absensi_rapat_2').value);
            fd.append("tanggal_rapat_3", this.tanggal_rapat_3);
            fd.append("filenya_undangan_rapat_3", document.getElementById('filenya_undangan_rapat_3').value);
            fd.append("filenya_notulensi_rapat_3", document.getElementById('filenya_notulensi_rapat_3').value);
            fd.append("filenya_dokumentasi_rapat_3", document.getElementById('filenya_dokumentasi_rapat_3').value);
            fd.append("filenya_absensi_rapat_3", document.getElementById('filenya_absensi_rapat_3').value);
            fd.append("tanggal_rapat_4", this.tanggal_rapat_4);
            fd.append("filenya_undangan_rapat_4", document.getElementById('filenya_undangan_rapat_4').value);
            fd.append("filenya_notulensi_rapat_4", document.getElementById('filenya_notulensi_rapat_4').value);
            fd.append("filenya_dokumentasi_rapat_4", document.getElementById('filenya_dokumentasi_rapat_4').value);
            fd.append("filenya_absensi_rapat_4", document.getElementById('filenya_absensi_rapat_4').value);
            fd.append("project_id", this.project_id);
            fd.append("kota1", kota1);
            fd.append("kota2", kota2);
            fd.append("kota3", kota3);
            fd.append("kota4", kota4);
            fd.append("createdby", JSON.parse(localStorage.getItem("isistem")));

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovation_tepis-UpdateTepis", fd).then(
                Response => {
                    var bytes = encodeURIComponent(CryptoJS.AES.encrypt(this.secretencData, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
                    if (Response.data.response == 'error') {
                        swal.fire('Peringatan', Response.data.message, 'error');
                    }
                    else {
                        swal.fire('Informasi', 'Data telah tersimpan..', 'success').then(function () {
                            window.location.replace("/Monev/" + bytes);
                        });
                    }
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )
        },
        formattulisrupiah(kodenya) {
            var rupiah = document.getElementById(kodenya);
            rupiah.addEventListener('keyup', function (e) {
                // tambahkan 'Rp.' pada saat form di ketik
                // gunakan fungsi formatRupiah() untuk mengubah angka yang di ketik menjadi format angka
                rupiah.value = formatRupiah(this.value, '');
            });

            /* Fungsi formatRupiah */
            function formatRupiah(angka, prefix) {
                var separator = '';
                var number_string = angka.replace(/[^,\d]/g, '').toString(),
                    split = number_string.split(','),
                    sisa = split[0].length % 3,
                    rupiah = split[0].substr(0, sisa),
                    ribuan = split[0].substr(sisa).match(/\d{3}/gi);

                // tambahkan titik jika yang di input sudah menjadi angka ribuan
                if (ribuan) {
                    separator = sisa ? '.' : '';
                    rupiah += separator + ribuan.join('.');
                }

                rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
                return prefix == undefined ? rupiah : (rupiah ? rupiah : '');
            }
        },
        getOtentifikasi() {
            var time = Date.parse(localStorage.getItem("tsistem"));
            var timeakhir = time + (3 * 60 * 60 * 1000);
            var timesekarang = Date.parse(new Date());
            if (timesekarang > timeakhir) {
                this.ClearlocalStorage();
            }
            this.halamanloading = false;
        },
        ontabelChange(a) {
            try {
                this.selectedtabel = this.tabel[a].tag;
            }
            catch (err) {
                return;
            }
        },
        batalproses() {
            var kode = encodeURIComponent(CryptoJS.AES.encrypt(this.secretencData, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            window.location.replace("/Monev/" + kode);
        },
        uploadfile(idnya, tipenya) {
            var elmnt = document.getElementById("fileToUpload" + idnya);
            try {
                var namanya = elmnt.files[0].name;
                //alert(elmnt.files[0]['type'].toUpperCase());
                if (tipenya == 'image/*') {
                    if ((elmnt.files[0]['type'].toUpperCase() != 'IMAGE/JPG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/JPEG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/PNG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/GIF')) {
                        document.getElementById('suksesnya' + idnya).innerHTML = '*file harus format gambar';
                        return;
                    }
                }
                else {
                    if (elmnt.files[0]['type'] != tipenya) {
                        document.getElementById('suksesnya' + idnya).innerHTML = '*file harus format pdf';
                        return;
                    }
                }
            } catch (error) {
                document.getElementById('suksesnya' + idnya).innerHTML = '*pilih file terlebih dahulu';
                return;
            }
            var fd = new FormData();
            fd.append("fileToUpload", elmnt.files[0], elmnt.files[0].name);
            fd.append("folderToUpload", idnya);
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovationpeta-FilesUpload", fd, {
                onUploadProgress: function (uploadEvent) {
                    document.getElementById('persennya' + idnya).style.width = Math.round((uploadEvent.loaded / uploadEvent.total) * 100) + "%";
                    document.getElementById('tulisanpersen' + idnya).innerHTML = Math.round((uploadEvent.loaded / uploadEvent.total) * 100) + "%";
                }
            }).then(
                function (res) {
                    document.getElementById('suksesnya' + idnya).innerHTML = res.data.message;
                    if (res.data.filename != undefined) {
                        document.getElementById(idnya).value = res.data.filename;
                    }
                }
            ).catch(function (e) {
                document.getElementById('suksesnya' + idnya).innerHTML = res.data.message;
                document.getElementById(idnya).value = '';
                console.log(e);
            }
            )
        },
        clearfilepeta(idnya) {
            if (document.getElementById(idnya).value == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'File Tidak Tersedia',
                });
                return false;
            }

            var fd = new FormData();
            fd.append("folderToUpload", idnya);
            fd.append("filenya", document.getElementById(idnya).value);
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovationpeta-FilesDeleted", fd).then(
                Response => {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: Response.data.message,
                    });
                    document.getElementById(idnya).value == '';
                    this.filenya_kendala = '';
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )

            document.getElementById('fileToUpload' + idnya).value = '';
            document.getElementById(idnya).value = '';
            document.getElementById('persennya' + idnya).style.width = "0%";
            document.getElementById('tulisanpersen' + idnya).innerHTML = "0%";
            document.getElementById('suksesnya' + idnya).innerHTML = '';
            return false;
        },
        async AmbilDataSingel() {
            this.halamanloading = true;
            if (this.selectedtahunmulai == '') {
                this.selectedtahunmulai = this.tahun;
            }
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });



            await mainAPI5.get("parastapainnovationreffmonitoring-Lokasi?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datalokasi = [];
                        this.lokasi = [];
                        this.datalokasi = Response.data.content.data;
                        this.datalokasi.forEach((item) => {
                            this.lokasi.push({
                                label: item.nama,
                                code: this.datalokasi.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.lokasi.unshift({
                            label: 'Pilih Lokasi',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            var tmp = this.secretencData.split("_");
            var terpilih = tmp[0];
            this.idnya = tmp[0];
            //alert(terpilih);
            await mainAPI.get("parastapainnovation_kpi2-Get?random=" + random + "&project_id=" + this.project_id + "&kode=" + terpilih + "&create=" + JSON.parse(localStorage.getItem("isistem"))).then(
                Response => {
                    this.datapesan = Response.data.message;
                    this.datamaster = [];
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datamaster = [];
                        this.datamaster = Response.data.content.data;
                        this.Nama_Kegiatan = Response.data.content.Nama_Kegiatan;
                        this.halamanloading = false;
                    }
                    else {
                        this.datamaster = [];
                        this.Nama_Kegiatan = '';
                        this.halamanloading = false;
                    }

                }
            ).catch(error => {
                //console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });
        },
        validasidata() {
            if (document.getElementById('tanggal').value == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Data',
                });
                document.getElementById('tanggal').focus();
                return false;
            }
            if (document.getElementById('target_penyelesaian').value == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Data',
                });
                document.getElementById('target_penyelesaian').focus();
                return false;
            }
            if (this.kendala == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Data Kendala',
                });
                return false;
            }
            if (this.tindaklanjut == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Data Tindak Lanjut',
                });
                return false;
            }
            if (this.penanggungjawab == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Data Penanggungjawab',
                });
                return false;
            }
            if (document.getElementById('filenya_kendala').value == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Foto',
                });
                return false;
            }
            this.validasi = true;
            return;
        },
        update() {
            this.validasidata();
            if (this.validasi == false) {
                return false;
            }
            var fd = new FormData();
            fd.append("tanggal", this.tanggal);
            fd.append("kendala", this.kendala);
            fd.append("tindaklanjut", this.tindaklanjut);
            fd.append("target_penyelesaian", this.target_penyelesaian);
            fd.append("penanggungjawab", document.getElementById('penanggungjawab').value);
            fd.append("project_id", this.project_id);
            fd.append("filenya_kendala", document.getElementById('filenya_kendala').value);
            fd.append("kode", this.secretencData);
            fd.append("updatedby", JSON.parse(localStorage.getItem("isistem")));
            fd.append("id", this.idnya);
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovation_kendala-Update", fd).then(
                Response => {
                    var bytes = encodeURIComponent(CryptoJS.AES.encrypt(this.secretencData, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
                    if (Response.data.response == 'error') {
                        swal.fire('Peringatan', Response.data.message, 'error');
                    }
                    else {
                        swal.fire('Informasi', 'Data telah terupdate..', 'success').then(function () {
                            window.location.replace("/KendalaTindakLanjut/" + bytes);
                        });
                    }
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )
            return false;
        },
    },
    mounted() {
        this.getOtentifikasi();
        this.ambildatareff();
        this.initialize();
        this.AmbilDataSingel();
    }
}
</script>
<style></style>